<template>
<v-container fluid class="login-container background-image">
   
    <div class="p-none row" style="align-items: center; justify-content: center; flex-direction: row; height: 100vh;">
        <div class="sign_insec">
            <v-subheader class="subtitle">
                <h1>CS Reporting Form</h1>
                <p>Please Enter The Details Below</p>
            </v-subheader>
            <v-text-field
                v-model="email"
                label="Email Address"
                placeholder=""
                :rules="emailRules"
                :error-messages="emailErrorMessages"
                class="email-text-field"
            ></v-text-field>
            <v-text-field
                v-model="password"
                label="Password"
                :type="pass_type"
                class="password-input"
                :rules="passwordRules"
                :error-messages="passwordErrorMessages"
            >
                <template v-slot:append-inner>
                    <v-icon 
                        @click="togglePasswordVisibility"
                        :class="'icon-left-padding'"
                    >
                        {{ pass_type === 'password' ? 'mdi-eye' : 'mdi-eye-off' }}
                    </v-icon>
                </template>
            </v-text-field>
            
            <!-- Loader section -->
            <div v-if="loading" class="loader">
                <v-progress-circular indeterminate size="54"></v-progress-circular>
            </div>

             <!-- Snackbar -->
             <v-snackbar v-model="snackbar.show" :color="snackbar.color" rounded="pill" location="top right"  :timeout="snackbar.timeout"  class="snack-bar" :style="{ bottom: `250px` , padding: '20px'}" absolute>
                <div class="text-center ">{{ snackbar.message }}</div>
            </v-snackbar>

            <v-btn @click.prevent="login()" class="signupbtn full-width prism_btn">
            LogIn
          </v-btn>

        </div>
    </div>
</v-container>
</template>

<script>
import axios from 'axios'
// import { BIcon } from 'bootstrap-vue';

{/* <b-icon :icon="showPassword ? 'eye-slash' : 'eye'"></b-icon> */}
export default {
    name: "Sign-Up",
    data() {
        return {
            pass_type: "password",
            email: "",
            password: "",
            isValidEmail: true,
            isValidPassword: true,
            msgInfo: "Please Enter Your Login Details",
            loading: false,
            snackbar: {
                show: false,
                color: '',
                message: '',
                timeout: 3000, // Adjust the timeout as needed (in milliseconds)
            },
            emailRules: [
                v => !!v || 'Email is required',
                v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Enter a valid email address',
            ],
            passwordRules: [
                v => !!v || 'Password is required',
                v => (v && v.length >= 6) || 'Password must be at least 6 characters',
            ],
        }
    },
    methods: {

        async login() {

            // Validate email
            this.isValidEmail = this.validateEmail(this.email);

            // Validate password
            this.isValidPassword = this.password.length >= 6;

            // If both email and password are valid, proceed with login logic
            if (this.isValidEmail && this.isValidPassword) {

                this.loading = true;

                try {
                    // Make a login API request using Axios
                    // const apiUrl = 'https://staging-admin-api.shoonya.com/admin/api/login';
                    const response = await axios.post('https://dev-admin-api.shoonya.com/admin/api/login', {
                        email: this.email,
                        password: this.password,
                    })
                    console.log(response);

                    if(response.data.info == "NOK") {
                        
                        this.loading = false;
                        this.showSnackbar(`${response.data.msg}`);
                        return
                    } else {
                        
                        const data = response.data.data;
    
                        localStorage.setItem('authToken', data.user.token);
                        localStorage.setItem('userDetails', JSON.stringify(data.user));
    
                        axios.defaults.headers.common['Authorization'] = `Bearer ${data.user.token}`;
    
                        // Handle the response as needed
                        console.log('Login successful:', response.data);
                        this.$router.push('/report');
                    }
                } catch (error) {
                    // Handle API request error
                    
                    console.error('Login failed:', error.response.data);
                }
            }

            // setTimeout(() => {
            //     // Reset loading state after the login process is completed
            //     this.loading = false;
            // }, 2000);

            

        },
        validateEmail(email) {
            // Basic email validation regex
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        togglePasswordVisibility() {
            this.pass_type = this.pass_type === 'password' ? 'text' : 'password';
        },
        showSnackbar(message, type) {
            this.snackbar.message = message;
            this.snackbar.color = type === 'success' ? 'success' : 'error';
            this.snackbar.show = true;
        }
        
    },
    computed: {
        emailErrorMessages() {
            const errors = [];
            if (!this.emailRules[0](this.email)) {
                errors.push('Email is required');
            }
            if (!this.emailRules[1](this.email)) {
                errors.push('Enter a valid email address');
            }
            return errors;
        },
        // Additional computed properties...
        passwordErrorMessages() {
            const errors = [];
            if (!this.passwordRules[0](this.password)) {
                errors.push('Password is required');
            }
            if (!this.passwordRules[1](this.password)) {
                errors.push('Password must be at least 6 characters');
            }
            return errors;
        },
    }

   
}
</script>
<style scoped>

    .signupbtn {
        padding-top: 30px;
        width: 50%;
    }
    .banner-svg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: -1; /* Send the banner to the background */
    }
    .container-fluid {
        position: relative; /* Ensure the banner stays behind the content */
    }
    .password-input .v-input__append-inner {
    padding-right: 8px;
    }
    .email-text-field {
        padding-top: 47px; /* Adjust the padding value as needed */
    }
    .eye-toggle {
        position: absolute;
        right: 10px;
        top: 50% !important;
        transform: translateY(-50%);
        background: none;
        border: none;
        color: black;
        cursor: pointer;
        outline: none;
        width: 40px !important;
        height: 40px !important;
        box-shadow: none !important;
    }
    .eye-toggle:hover {
        box-shadow: none;
    }
    .icon-left-padding {
    margin-left: 16px; /* Adjust the margin value as needed */
}
    .float-field {
        padding-right: 30px; /* Adjust as needed to make room for the button */
    }
    .custom-icon {
         background-color: transparent !important;
    }
    .form-group.field-wrapper {
        margin-bottom: 25px;
    }
    .message {
        padding-top: 15px;
        text-align: left;
        text-transform: none;
        font-size: 90%;
        padding-left: 10px;
    }
    /* .float-label {
        background: var(--placeholdertext) !important;
        color: white;
        padding: 5px !important;
    } */
     .v-field__append-inner, .v-field--center-affix .v-field__clearable, .v-field--center-affix .v-field__prepend-inner {
        padding-left: 9px !important;
    }
    .v-field__append-inner {
        padding-left: 16px !important;
    }
    .password-input .v-input__append-inner {
        padding-left: 16px !important; /* Adjust the padding value as needed */
        background-color: inherit;
}
    .v-field__field {
        padding-right: 10px !important;
    }
    .v-messages {
        text-align: left !important;
        padding-top: 8px; /* Adjust the padding value as needed */
    }
    .login-container {
        background: rgb(53 151 103 / 33%);
        height: 100vh;
        overflow: hidden;
    }
    .login-container::-webkit-scrollbar {
        display: none;
    }
    .background-image {
        background-image: url('../../static/images/new-background.svg');
        background-size: cover;
        background-position: center;
    }

    

</style>
